import Login from '@/pages/login/Login.vue';

export default {
  path: '/',
  name: 'login',
  component: Login,
  meta: {
    hideMainMenu: true,
    role: {
      sectorId: 'login',
    },
  },
};
